<template>
	<div>
		<div class="md-layout" v-if="registration_success">
			<div class="md-layout-item" style="text-align: center;line-height: 32px;">
				<h3 style="color: green;">
					<b>{{$store.state.locale.locale.successRegistration[$store.state.locale.lang]}}</b>
				</h3>
				<div>
					<md-icon
						style="color:green;font-size: 100px !important;height:100px !important; width: 100px !important;">
						check_circle</md-icon>
				</div>


				<h3>{{$store.state.locale.locale.thankyou[$store.state.locale.lang]}}</h3>
				<h3>{{$store.state.locale.locale.refText[$store.state.locale.lang]}} {{reference_code}}</h3>
				<div style="width: 100%; display: flex; justify-content: center;">
					<qr-code :text="reference_code" :size="200" style="width:200px;border:10px solid white"></qr-code>
				</div>
				<h4>
					{{$store.state.locale.locale.saveRefCode[$store.state.locale.lang]}}<br>{{$store.state.locale.locale.refCodeDetail[$store.state.locale.lang]}}
				</h4>
			</div>
		</div>
		<div v-if="!registration_success">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-100" style="margin-bottom: 21px;">
					<img src="@/assets/img/cover.jpeg" />
				</div>
				<div class="md-layout-item md-size-100">
					<!-- {{registration_hash}} {{registration_id}} -->
					<p style="margin-top: 21px; text-align: justify;">
						<b>{{$store.state.locale.locale.registrationDesc1[$store.state.locale.lang]}}</b>

					</p>
					<p style="text-align: justify;">{{$store.state.locale.locale.registrationDesc2[$store.state.locale.lang]}}</p>
					<p style="text-align: justify;">{{$store.state.locale.locale.registrationDesc3[$store.state.locale.lang]}}</p>
					<p>
						<b>{{$store.state.locale.locale.registrationDesc4[$store.state.locale.lang]}}<br>
							{{$store.state.locale.locale.registrationDesc5[$store.state.locale.lang]}}<br>
							{{$store.state.locale.locale.registrationDesc6[$store.state.locale.lang]}}<br></b>
					</p>
					<p style="color:red; text-align: right;">
						{{$store.state.locale.locale.required[$store.state.locale.lang]}}
					</p>
					<h3 style="text-transform: uppercase;">
						{{$store.state.locale.locale.personalInfo[$store.state.locale.lang]}}
					</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>{{$store.state.locale.locale.name[$store.state.locale.lang]}}</label>
						<md-input type="text" v-model="user.name" spellcheck="false"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>{{$store.state.locale.locale.gender[$store.state.locale.lang]}}</label>
						<md-select :placeholder="$store.state.locale.locale.gender[$store.state.locale.lang]"
							v-model="user.gender">
							<md-option value="f">{{$store.state.locale.locale.female[$store.state.locale.lang]}}</md-option>
							<md-option value="m">{{$store.state.locale.locale.male[$store.state.locale.lang]}}</md-option>
							<md-option value="o">{{$store.state.locale.locale.other[$store.state.locale.lang]}}</md-option>
						</md-select>
					</md-field>
				</div>
				<!-- <div class="md-layout-item md-small-size-50 md-size-30">
					<md-field>
						<label>{{$store.state.locale.locale.age[$store.state.locale.lang]}}</label>
						<md-input type="number" v-model="user.age">
						</md-input>
					</md-field>
				</div> -->
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>{{$store.state.locale.locale.phone[$store.state.locale.lang]}}</label>
						<md-input type="text" v-model="user.phone">
						</md-input>
					</md-field>
				</div>
				<!-- <div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>{{$store.state.locale.locale.email[$store.state.locale.lang]}}</label>
						<md-input type="text" v-model="user.email">
						</md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>{{$store.state.locale.locale.institution[$store.state.locale.lang]}}</label>
						<md-input type="text" v-model="user.institution">
						</md-input>
					</md-field>
				</div> -->
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>{{$store.state.locale.locale.occupation[$store.state.locale.lang]}}</label>
						<md-select :placeholder="$store.state.locale.locale.occupation[$store.state.locale.lang]" v-model="user.occupation">
							<md-option :value="o.en" v-for="o in occupation_list">{{o[$store.state.locale.lang]}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>{{$store.state.locale.locale.interest[$store.state.locale.lang]}}</label>
						<md-select :placeholder="$store.state.locale.locale.interest[$store.state.locale.lang]" v-model="user.interest">
							<md-option :value="i.en" v-for="i in interest_list">{{i[$store.state.locale.lang]}}</md-option>
						</md-select>
					</md-field>
				</div>
				<!-- <div class="md-layout-item md-small-size-100 md-size-100">
					<md-field>
						<label>{{$store.state.locale.locale.other_data[$store.state.locale.lang]}}</label>
						<md-input type="text" v-model="user.other_data"></md-input>
					</md-field>
				</div> -->

				<div class="md-layout-item md-size-100">
					<h3 style="text-transform: uppercase;">
						{{$store.state.locale.locale.personalID[$store.state.locale.lang]}}
					</h3>
					<p style="line-height: 32px;">
						<b>{{$store.state.locale.locale.idCard[$store.state.locale.lang]}}
						</b>{{$store.state.locale.locale.idCardDetail[$store.state.locale.lang]}}<br>
						<b>{{$store.state.locale.locale.selfie[$store.state.locale.lang]}}
						</b>{{$store.state.locale.locale.selfieDetail[$store.state.locale.lang]}}<br>
					</p>
				</div>

				<div class="md-layout">
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-50 file-image"
						style="text-align: center;">
						<div class="file-image-wrapper">
							<h6>{{$store.state.locale.locale.idCardBox[$store.state.locale.lang]}} <span class="red">*</span></h6>
							<div class="md-layout-item md-small-size-100 md-size-100" style="min-height: 150px;">
								<input type="file" ref="id_card" accept="image/*" style="display: none;"
									@change="processFile($event, 'id_card')">
								<img class="thumb-product" src="/id-card.png" v-if="image.id_card.length == 0">
								<img class="thumb-product" :src="image.id_card" v-if="image.id_card.length > 12">
								<img class="thumb-product" :src="config.getProductUrl(image.id_card)"
									v-if="image.id_card.length == 12">
							</div>
							<md-button class="md-primary" @click="openImage('id_card')" v-if="image.id_card.length == 0">
								{{$store.state.locale.locale.upload[$store.state.locale.lang]}}
							</md-button>
							<md-button class="md-primary" @click="removeImage('id_card')" v-else>
								{{$store.state.locale.locale.remove[$store.state.locale.lang]}}</md-button>
						</div>
					</div>

					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-50 file-image"
						style="text-align: center;">
						<div class="file-image-wrapper">
							<h6>{{$store.state.locale.locale.selfieBox[$store.state.locale.lang]}} <span class="red">*</span></h6>
							<div class="md-layout-item md-small-size-100 md-size-100" style="min-height: 150px;">
								<input type="file" ref="personal_photo" accept="image/*" style="display: none;"
									@change="processFile($event, 'personal_photo')">
								<img class="thumb-product" src="/selfie.png" v-if="image.personal_photo.length == 0">
								<img class="thumb-product" :src="image.personal_photo" v-if="image.personal_photo.length > 12">
								<img class="thumb-product" :src="config.getProductUrl(image.personal_photo)"
									v-if="image.personal_photo.length == 12">

							</div>
							<md-button class="md-primary" @click="openImage('personal_photo')"
								v-if="image.personal_photo.length == 0">
								{{$store.state.locale.locale.upload[$store.state.locale.lang]}}
							</md-button>
							<md-button class="md-primary" @click="removeImage('personal_photo')" v-else>
								{{$store.state.locale.locale.remove[$store.state.locale.lang]}}</md-button>
						</div>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-size-100" style="margin-top: 5px"><span class="red">*</span> {{$store.state.locale.locale.revoke[$store.state.locale.lang]}}</div>
				</div>
			</div>

			<div class="md-layout-item md-size-100" style="padding-top: 13px">
				<p>
					<md-checkbox v-model="user.agree" class="md-primary">
						{{$store.state.locale.locale.confirmEmail[$store.state.locale.lang]}}</md-checkbox>
				</p>
				<!-- <vue-recaptcha ref="captcha" sitekey="6LcR_tccAAAAAIYbzcQKe4tqan-5i3TxZUJ7D_lv" :loadRecaptchaScript="true"
					@verify="getCapt" @expired="resetCaptcha"></vue-recaptcha><br> -->
				<!-- <p style="line-height: 30px;">{{$store.state.locale.locale.bySubmit[$store.state.locale.lang]}} <a
						href="/privacy_policy"
						target="_blank">{{$store.state.locale.locale.term[$store.state.locale.lang]}}</a>
					{{$store.state.locale.locale.and[$store.state.locale.lang]}} <a href="/privacy_policy"
						target="_blank">{{$store.state.locale.locale.dataPolicy[$store.state.locale.lang]}}</a>{{$store.state.locale.locale.we[$store.state.locale.lang]}}
				</p> -->


				<!-- <md-checkbox v-model="user.agree" class="md-primary" @change="checkValidation()">I agree to the Terms &
				Conditions</md-checkbox> -->
			</div>
			<div class="md-layout-item md-size-100 text-right">

				<md-button :class="{'md-raised': true, 'md-primary': true}" @click="checkValidation()">
					{{$store.state.locale.locale.register[$store.state.locale.lang]}}</md-button>


			</div>
			<md-dialog-alert :md-active.sync="infoDialog"
				:md-content="$store.state.locale.locale.invalid[$store.state.locale.lang]" md-confirm-text="OK"
				@md-confirm="onClose" />
			<md-dialog-confirm :md-active.sync="confirmDialog"
				:md-title="$store.state.locale.locale.confirmRegister[$store.state.locale.lang]"
				:md-confirm-text="$store.state.locale.locale.register[$store.state.locale.lang]"
				:md-cancel-text="$store.state.locale.locale.cancel[$store.state.locale.lang]" @md-cancel="onClose"
				@md-confirm="createuser" />

		</div>

	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	import Compressor from 'compressorjs';
	import VueQRCodeComponent from 'vue-qr-generator'
	import VueRecaptcha from 'vue-recaptcha';
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime,
			VueRecaptcha,
			'qr-code': VueQRCodeComponent,
		},
		created() {

			this.registration_id = this.config.hash(32);
			this.registration_hash = this.config.sha256(this.registration_id);
			// this.getSettings();
		},
		mounted() {
			// setTimeout(() => {
			// 	// console.log(grecaptcha.render);
			// 	// if(grecaptcha.render == 'function') {
			// 		grecaptcha.render("recaptcha", {sitekey: "6Le5rfsSAAAAAINrhL_oAsCIiH-heQ91vwPKtJgQ"});
			// 	// }
			// },3000)
		},
		data() {
			return {
				registration_hash: "",
				registration_id: "",
				registration_success: false,
				image: {
					id_card: "",
					personal_photo: ""
				},
				user: {
					name: "",
					age: "100",
					gender: "",
					phone: "",
					email: "default@airandtech.show",
					institution: "DEFAULT",
					occupation: "",
					interest: "",
					other_data: "DEFAULT",
					id_card_token: "",
					personal_photo_token: "",
					token: "",
					agree: null
				},
				reference_code: "",
				isValid: false,
				infoDialog: false,
				confirmDialog: false,
				occupation_list: [
					{ en: 'Student *', km: "សិស្សនិស្សិត" },
					{ en: 'Engineer *', km: "វិស្វករ" },
					{ en: 'Scientist *', km: "អ្នកវិទ្យាសាស្រ្ត" },
					{ en: 'Businessman/woman *', km: "អ្នកប្រកបអាជីវកម្ម" },
					{ en: 'Educator *', km: "អ្នកអប់រំ" },
					{ en: 'Government Official *', km: "មន្រ្តីរាជការ" },
					{ en: 'Other *', km: "ផ្សេងទៀត" }
				],
				interest_list: [
				{ en: 'Visit exhibitions *', km: "ការតាំងពិព័រណ៍" },
				{ en: 'Panel discussion & sharing', km: "ស្ដាប់ការពិភាក្សា" },
				{ en: 'Expand knowledge & networking', km: "ពង្រីកចំណេះដឹង និងបណ្តាញ" },
				{ en: 'Explore investment opportunities', km: "ស្វែងរកឱកាសវិនិយោគ" },
				{ en: 'Other *', km: "ផ្សេងទៀត" }

				]
			}
		},
		methods: {
			// getSettings() {
			// 	this.$http.get(this.config.api + "/public/location/get/all").then(data => {
			// 		this.districtList = data.body.data.district
			// 		this.provinceList = data.body.data.province
			// 		this.communeList = data.body.data.commune
			// 	})
			// },


			createuser() {
				// alert("go");
				let dob = (new Date(this.user.dob)).getTime();
				this.$http.post(this.config.api + "/public/ticket/post", {
					user: this.user,
					// dob,
					// token: this.user.token,
					registration_id: this.registration_id
				}).then(res => {
					if (res.body.status == 'success') {
						// this.$notification.notify({
						// 	message: "Registration was successful.",
						// 	icon: 'done',
						// 	type: 'success'
						// })
						// this.$router.push('/data');
						// this.reference_code = res.body.data.reference_code;
						// this.$cookie.set('ref_code', res.body.data.reference_code, 60);
						// this.registration_success = true;
						this.$router.push("/pass/" + res.body.data.ticket_id);

					}
					// this.resetCaptcha();
				})
			},
			switchProvince(p) {
				let filtered = [];
				for (let i = 0; i < this.districtList.length; i++) {
					if (this.districtList[i].province_id == this.user.address_province) {
						filtered.push(this.districtList[i])
					}
				}
				this.districtAddressFilteredList = filtered;
				this.user.address_district = "";
				this.user.address_commune = "";
			},
			switchDistrict(d) {

				let filtered = [];
				for (let i = 0; i < this.communeList.length; i++) {
					if (this.communeList[i].district_id == this.user.address_district) {
						filtered.push(this.communeList[i])
					}
				}
				this.communeAddressFilteredList = filtered;
				this.user.address_commune = "";

			},
			getCapt(token) {
				// console.log(token);
				this.user.token = token;
			},

			processFile(e, type) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				this.image[type] = "/loading-image.gif";
				var self = this
				new Compressor(files[0], {
					quality: 0.5,
					maxWidth: 2500,
					minWidth: 500,
					minHeight: 500,
					maxHeight: 2500,
					convertSize: 3000000,
					// The compression process is asynchronous,
					// which means you have to access the `result` in the `success` hook function.
					success(result) {
						let formData = new FormData();

						formData.append("image", result, 'imagepro');
						formData.append("registration_hash", self.registration_hash);
						self.$http.post(self.config.api + '/public/image_upload', formData).then(res => {
							if (res.body.status == 'success') {

								self.user[type + "_token"] = res.body.data.token

								var reader = new FileReader();

								reader.onload = function (e) {
									self.image[type] = e.target.result
								};

								reader.readAsDataURL(result);
							}
						})
						// self.user[type] = result;
						// console.log(result);

					},
					error(err) {
						self.$notification.notify({
							message: "Error compressing, please upload new image.",
							icon: 'error',
							type: 'danger'
						})
					},
				});




			},
			openImage(type) {
				// console.log(this.$refs);
				this.$refs[type].click();


			},
			resetCaptcha() {
				console.log("reCaptcha reset.")
				this.$refs.captcha.reset();
			},
			removeImage(type) {
				// console.log(this.$refs);
				this.image[type] = "";
				this.user[type + "_token"] = "";
				// this.checkValidation();
			},
			onClose() {
				this.infoDialog = false
				this.confirmDialog = false
			},
			checkValidation() {
				if (String(this.user.name).length > 0 &&
					String(this.user.gender).length > 0 &&
					String(this.user.age).length > 0 &&
					String(this.user.phone).length > 0 &&
					String(this.user.email).length > 0 &&
					String(this.user.institution).length > 0 &&
					String(this.user.occupation).length > 0 &&
					String(this.user.interest).length > 0 &&
					String(this.user.id_card_token).length > 0 &&
					String(this.user.personal_photo_token).length > 0 &&
					String(this.user.agree) == 'on') {
					this.confirmDialog = true
					this.infoDialog = false
				} else {
					this.infoDialog = true
					this.confirmDialog = false
				}
			}
		}
	}
	// var onloadCallback = function () {
	// 	grecaptcha.render('recaptcha', {
	// 		'sitekey': '6Le5rfsSAAAAAINrhL_oAsCIiH'
	// 	});
	// };
</script>
<style>
	/* .product-thumbnail {
		width: 64px;
		height: 64px;
	} */

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		/* width: 100% !important; */
		width: 60% !important;
		height: auto;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 10px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}


	/* .thumb-product {
		width: 100%;
	} */
</style>



// WEBPACK FOOTER //
// src/pages/Registration/View.vue